$(document).ready(function () {
    $('.calendar-select-day').on('change', function() {
        var date = $(this).val();
        var year = date.substring(0, 4);
        var month = date.substring(5, 7);
        var day = date.substring(8, 10);
        var url = "/calendar/day/" + year + "/" + month + "/" + day;
        window.location.assign(url);
    });
    $('.calendar-select-month').on('change', function() {
        var date = $(this).val();
        var year = date.substring(0, 4);
        var month = date.substring(5, 7);
        var url = "/calendar/month/" + year + "/" + month;
        window.location.assign(url);
    });
    $('.calendar-select-year').on('change', function() {
      var year = $(this).val();
      var url = "/calendar/year/" + year;
      window.location.assign(url);
    });
});
